import { render, staticRenderFns } from "./NudgeBanner.vue?vue&type=template&id=2fc569d4&scoped=true"
import script from "./NudgeBanner.vue?vue&type=script&lang=ts"
export * from "./NudgeBanner.vue?vue&type=script&lang=ts"
import style0 from "./NudgeBanner.vue?vue&type=style&index=0&id=2fc569d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc569d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc569d4')) {
      api.createRecord('2fc569d4', component.options)
    } else {
      api.reload('2fc569d4', component.options)
    }
    module.hot.accept("./NudgeBanner.vue?vue&type=template&id=2fc569d4&scoped=true", function () {
      api.rerender('2fc569d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Banner/NudgeBanner.vue"
export default component.exports